import { h } from 'preact';
import CloseIcon from 'utils/icon/icon-close.svg';
import ArrowLeftIcon from 'utils/icon/icon-arrow-left.svg';
import { useMemo } from 'preact/hooks';
import CartGwpProduct from './cart-gwp-product';

const CartGwpProducts = ({ gwp, addedItems, onClose }) => {
  const label = useMemo(() => {
    if (gwp.selectGiftMessage) {
      return gwp.selectGiftMessage;
    }

    if (addedItems.length === parseInt(gwp.giftQuantity, 10)) {
      return window.TMW.Strings.cart.gifts.giftsAdded;
    }
    if (addedItems.length < 3) {
      return window.TMW.Strings.cart.gifts[`selectGift${addedItems.length + 1}`];
    }
    return window.TMW.Strings.cart.gifts.selectGifts;
  }, [gwp, addedItems]);

  const showCounter = parseInt(gwp.giftQuantity, 10) > 1;

  const products = useMemo(() => {
    if (gwp.giftCollections?.length) {
      return gwp.giftCollections.reduce((acc, collection) => acc.concat(collection), []);
    }
    const items = {};
    gwp.giftProducts.forEach((item) => {
      if (!items[item.product.id]) {
        items[item.product.id] = {
          ...item.product,
          variants: [],
        };
      }
      items[item.product.id].variants.push(item.variant);
    });
    return Object.values(items).map((product) => {
      const variantOptions = product.variants.reduce((acc, variant) => {
        variant.selectedOptions.forEach((option) => {
          if (!acc[option.name]) {
            acc[option.name] = [];
          }
          if (!acc[option.name].includes(option.value)) {
            acc[option.name].push(option.value);
          }
        });
        return acc;
      }, {});
      return {
        ...product,
        options: product.options.map((option) => ({
          ...option,
          optionValues: option.optionValues.filter((value) => variantOptions[option.name].includes(value.name)),
        })),
      };
    });
  }, [gwp]);

  if (!products.length) {
    return null;
  }

  return (
    <div className="absolute left-0 top-0 z-50 flex h-full w-full flex-col bg-white">
      <div className="flex justify-between border-b border-grey-5 p-20">
        <button
          className=" text-faded-black lg:right-20"
          aria-label={window.TMW.Strings.cart.close}
          onClick={onClose}
        >
          <ArrowLeftIcon className="h-17 w-auto" />
        </button>
        <button
          className=" text-faded-black lg:right-20"
          aria-label={window.TMW.Strings.cart.close}
          onClick={onClose}
        >
          <CloseIcon className="h-17 w-auto" />
        </button>
      </div>
      <div className="h4 flex justify-between border-b border-grey-5 p-20 text-primary">
        <div>{label}</div>
        {showCounter && (
          <div>
            {addedItems.length}/{gwp.giftQuantity}
          </div>
        )}
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        {products.map((product) => (
          <CartGwpProduct
            key={product.id}
            product={product}
            gwpId={gwp.id}
            isDisabled={addedItems.length === parseInt(gwp.giftQuantity, 10)}
            cartItem={addedItems.find((i) => i.product_id === product.idClean)}
          />
        ))}
      </div>
    </div>
  );
};

export default CartGwpProducts;
